import { render, staticRenderFns } from "./ListaFormularioCard.vue?vue&type=template&id=878c631e"
import script from "./ListaFormularioCard.vue?vue&type=script&lang=js"
export * from "./ListaFormularioCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports